import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { userState } from '../../service/database'
import { useRecoilState } from 'recoil'
import { Button, Typography, Row, Col, Card, Input, Divider, Modal, Alert, Flex, Breadcrumb, Checkbox, Popover, Tooltip, } from 'antd'
import { useNavigate, Link } from 'react-router-dom'
import api from '../../service/axios'
import { useToasts } from 'react-toast-notifications';
import { isMobile } from 'react-device-detect';
import {
  CheckOutlined,
  HomeOutlined
} from '@ant-design/icons';
import { validateEmail } from '../../service/util'
import dayjs from 'dayjs'



export const AreaRegistrado = (props) => {

  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [senha1, setSenha1] = useState('')
  const [senha2, setSenha2] = useState('')
  const [senha3, setSenha3] = useState('')
  const [loading, setLoading] = useState(false)
  const { addToast } = useToasts()
  const [msg, setMsg] = useState(undefined)
  const [sitioEletronico, setSitioEletronico] = useState({})



  useEffect(() => {

console.log(user)

    let sitio = {
      email: user.email,
      emailprimary: user.emailprimary,
      aceitoem: user.aceitoem,
      cpfcnpj: user.cpf
    }

    if (validateEmail(sitio.email) || validateEmail(sitio.emailprimary)) {
      if (!sitio.aceitoem) {
        if (!validateEmail(sitio.email)) {
          sitio.email = sitio.emailprimary
        }
        sitio.open = true
      }
      setSitioEletronico({ ...sitio })
    }


  }, [])


  function renderEmail(){
    if(user?.email)
      return user.email
    else
      return user?.emailprimary
  }

  async function alterarSenha() {
    try {
      setLoading(true)
      if (senha2.length < 6) {
        setMsg("A senha deve conter pelo menos 6 caracteres!")
        return
      }

      if (senha2 !== senha3) {
        setMsg("As senhas não são iguais!")
        return
      }

      setLoading(true)
      await api.post('alterar-senha', {
        atual: senha1,
        nova: senha2,
        nova2: senha3,
        cpfcnpj: user.cpf
      })
      setIsModalOpen(false)
      addToast("Senha alterada com sucesso!", { appearance: 'success', autoDismiss: true });

    } catch (erro) {
      addToast(erro.message, { appearance: 'error', autoDismiss: true });
    }



  }



  return <Flex vertical>
    <Flex>
      <Breadcrumb items={[
        {
          title: <Flex align='center' gap={5}>
            <HomeOutlined />
            <Flex>Home</Flex>
          </Flex>,
        }
      ]} />
    </Flex>

    <Flex gap={isMobile ? 1 : 10} flex={1}>
      <Card size='small' title={"CRQ10/CE"} style={{ marginTop: 15, width: '100%' }}>
        <Flex vertical gap={4}>
          <Row gutter={[12, 12]} style={{ alignItems: 'center' }}>
            <Col span={3}><Flex justify='flex-end' align='center'>Nome</Flex></Col>
            <Col span={21}><Input disabled value={user?.nome} style={{ color: '#3e3c3c' }} /></Col>
            <Col span={isMobile ? 5 : 3}><Flex justify='flex-end' align='center'>CRQ</Flex></Col>
            <Col span={isMobile ? 19 : 5}><Input disabled value={user?.crq} style={{ color: '#3e3c3c' }} /></Col>
            <Col span={isMobile ? 5 : 3}>{user.isprofissional === 1 && <Flex justify='flex-end' align='center'>Categoria</Flex>}</Col>
            <Col span={isMobile ? 19 : 13}>{user.isprofissional === 1 && <Input style={{ color: '#3e3c3c' }} disabled value={user?.categoria} />}</Col>


          </Row>
        </Flex>
      </Card>
    </Flex>

    <Flex gap={10} flex={1}>
      <Card size='small' title={"Endereço"} style={{ marginTop: 15, width: '100%' }}>
        <Flex vertical gap={4}>
          <Row gutter={[12, 12]} style={{ alignItems: 'center' }}>

            <Col span={isMobile ? 5 : 3}><Flex justify='flex-end' align='center'>Endereço</Flex></Col>
            <Col span={isMobile ? 19 : 11}><Input style={{ color: '#3e3c3c' }} disabled value={user?.endereco} /></Col>
            <Col span={isMobile ? 5 : 3}><Flex justify='flex-end' align='center'>Bairro</Flex></Col>
            <Col span={isMobile ? 19 : 7}><Input style={{ color: '#3e3c3c' }} disabled value={user?.bairro} /></Col>

            <Col span={isMobile ? 5 : 3}><Flex justify='flex-end' align='center'>Cidade</Flex></Col>
            <Col span={isMobile ? 19 : 11}><Input style={{ color: '#3e3c3c' }} disabled value={user?.cidade} /></Col>
            <Col span={isMobile ? 5 : 3}><Flex justify='flex-end' align='center'>CEP</Flex></Col>
            <Col span={isMobile ? 7 : 3}><Input style={{ color: '#3e3c3c' }} disabled value={user?.cep} /></Col>
            <Col span={isMobile ? 5 : 2}><Flex justify='flex-end' align='center'>UF</Flex></Col>
            <Col span={isMobile ? 7 : 2}><Input style={{ color: '#3e3c3c' }} disabled value={user?.uf} /></Col>
          </Row>
        </Flex>
      </Card>
    </Flex>

    <Flex gap={10} flex={1}>
      <Card size='small' title={"Dados de Contato"} style={{ marginTop: 15, width: '100%' }}>
        <Flex vertical gap={4}>
          <Row gutter={[12, 12]} style={{ alignItems: 'center' }}>
            <Col span={isMobile ? 5 : 4}><Flex justify='flex-end' align='center'>Celular</Flex></Col>
            <Col span={isMobile ? 19 : 8}><Input style={{ color: '#3e3c3c' }} disabled value={user?.telefone} /></Col>
            <Col span={isMobile ? 5 : 4}><Flex justify='flex-end' align='center'>E-mail</Flex></Col>
            <Col span={isMobile ? 19 : 8}>
              <Flex align='center' gap={5}>
                <Input disabled value={renderEmail()} style={{ color: '#3e3c3c' }} />
                {sitioEletronico.aceitoem && <Tooltip color={"#183559"} title={<Flex vertical style={{ fontSize: '0.9em' }}>
                  <Flex><b>Sítio Eletrônico</b></Flex>
                  <Flex>
                    Confirmado: {dayjs(sitioEletronico.aceitoem).format('DD/MM/YYYY [às] HH:mm:ss')}
                  </Flex>
                </Flex>}>
                  <CheckOutlined />
                </Tooltip>
                }
              </Flex>
            </Col>
          </Row>
        </Flex>
      </Card>
    </Flex>

    <Modal
      title="Alteração de Senha"
      open={isModalOpen}
      width={300}
      afterClose={() => {
        setMsg(undefined)
        setSenha1('')
        setSenha2('')
        setSenha3('')
        setLoading(false)
      }}
      onOk={() => alterarSenha()}
      onCancel={() => setIsModalOpen(false)}>
      <Row gutter={[12, 4]}>
        <Col span={24}>Senha atual</Col>
        <Col span={24}>
          <Input.Password value={senha1} onChange={(e) => setSenha1(e.target.value)} />
        </Col>
        <Col span={24}>Nova senha</Col>
        <Col span={24}><Input.Password value={senha2} onChange={(e) => setSenha2(e.target.value)} /></Col>
        <Col span={24}>Confirme a senha</Col>
        <Col span={24}><Input.Password value={senha3} onChange={(e) => setSenha3(e.target.value)} /></Col>
        <Col span={24}>{(msg && loading === true) && <Alert message={msg}>
        </Alert>}
        </Col>
      </Row>
    </Modal>



    <Modal
      width={600}
      open={sitioEletronico.open}
      title={"Consentimento para Domicílio Eletrônico"}
      closable={false}
      footer={
        <Flex justify='flex-end' gap={20}>
          <Button onClick={() => setSitioEletronico({ ...sitioEletronico, open: false })}>Cancelar</Button>
          <Button
            loading={loading}
            style={{ width: 100 }}
            disabled={!sitioEletronico.aceite || !validateEmail(sitioEletronico.email)}
            type='primary' onClick={async () => {
              try {
                setLoading(true)
                await api.post('api/v1.0/registrado/sitio-aceite', sitioEletronico,
                  {
                    headers: {
                      'x-access-token': user?.token2
                    },
                    params: {
                    }
                  }
                )
                addToast('Dados atualizados com sucesso!', {
                  appearance: 'success',
                  autoDismiss: true
                })

                let _user = JSON.parse(JSON.stringify(user))
                _user.aceitoem = dayjs().format('YYYY-MM-DD HH:mm:ss')
                _user.email = sitioEletronico.email

                setUser(_user)
                setSitioEletronico({ ...sitioEletronico, aceitoem: dayjs().format('YYYY-MM-DD HH:mm:ss') })
                console.log(user)

              } catch (error) {
                addToast(error.message, { autoDismiss: true, appearance: 'error' })
              }
              setSitioEletronico({ ...sitioEletronico, open: false })
              setLoading(false)
            }}>Salvar</Button>

        </Flex>
      }>
      <Flex vertical gap={5}>
        <Divider style={{ marginTop: 5, marginBottom: 5 }} />

        <Flex align='center' gap={5}>
          <Flex style={{ wordBreak: 'normal', whiteSpace: 'nowrap' }}>E-mail</Flex>
          <Input
            placeholder='Seu e-mail'
            value={sitioEletronico.email} onChange={(e) => setSitioEletronico({ ...sitioEletronico, email: e.target.value })} />
        </Flex>
        {
          !validateEmail(sitioEletronico.email) && <Flex style={{ fontSize: '0.8em', color: 'red', marginLeft: 60 }}>
            Informe um e-mail válido!
          </Flex>
        }

        <Checkbox
          style={{ marginTop: 10 }}
          value={sitioEletronico.aceite}
          checked={sitioEletronico.aceite}
          onChange={(e) => setSitioEletronico({
            ...sitioEletronico, aceite: e.target.checked
          })}>
          <b>Declaro que li e concordo com o uso do meu e-mail como domicílio eletrônico.</b>
        </Checkbox>

        <Flex vertical gap={20}>
          <Flex>
            Ao marcar esta opção, você autoriza o Conselho Regional de Química da 10ª Região a utilizar o e-mail cadastrado como meio
            oficial de comunicação para envio de notificações, intimações, documentos e demais atos administrativos.
          </Flex>

          <Flex vertical gap={0}>
            <Flex>
              <b>Você declara estar ciente de que:</b>
            </Flex>

            <ul>
              <li>As comunicações enviadas para o e-mail informado serão consideradas válidas para todos os efeitos legais;</li>
              <li>É sua responsabilidade manter o e-mail atualizado e ativo no sistema;</li>
              <li>Deve acompanhar regularmente sua caixa de entrada, incluindo spam/lixo eletrônico;</li>
              <li>A falta de leitura das mensagens não invalida as comunicações realizadas pelo Conselho.</li>
            </ul>

          </Flex>
        </Flex>

      </Flex>

      <Divider style={{ marginTop: 15, marginBottom: 15 }} />

    </Modal>


  </Flex >


}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(AreaRegistrado)